export default "__VITE_ASSET__BPr00q8v__"